import React from "react";
const ContentType2 = ({ item }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        fontSize: "2vmax",
      }}
    >
      <img
        style={{ width: "70%", height: "40%", marginTop: "1vh" }}
        src={item.img}
        alt="img site"
      />
      <a href={item.hyperText} target="_blank" rel="noreferrer">
        {item.hyperText}
      </a>
      <p>{item.text}</p>
    </div>
  );
};

export default ContentType2;
